import React, { useEffect, useState } from "react";
import { NavBar, SideBar, Breadcrumb, UpdateSignature } from "../components";
import { handleOnClickLogout, getAllCards, getSignature } from "../constants";
import { useNavigate, useParams } from "react-router-dom";

const UpdatedSignature = () => {
  const user = JSON.parse(localStorage.getItem("user_info"));
  const token = user.access_token;
  const navigate = useNavigate();
  const [initial, setInitial] = useState(false);
  const [signatureData, setSignatureData] = useState({});
  const [cards, setCards] = useState([]);
  const { emailSignatureId } = useParams();
  const [loading, setLoading] = useState(false);
  const [breads, setBreads] = useState(["Emails"]);
  const changeBreadCrumbs = (i) => {
    setBreads(breads.slice(0, i + 1));
  };
  useEffect(() => {
    if (breads.length < 2 && initial) {
      navigate("/signatures");
    }
  }, [breads]);

  useEffect(() => {
    if (Object.keys(signatureData).length > 0) {
      if (breads.length == 1) {
        setBreads([...breads, signatureData.name]);
      }
    }
    setInitial(true);
  }, [signatureData]);

  useEffect(() => {
    getSignature(token, emailSignatureId, setSignatureData);
    getAllCards(token, setCards);
  }, []);

  return (
    <div className="flex flex-col bg-white w-full h-screen overflow-hidden justify-start items-center text-secondary">
      <NavBar
        handleLogout={handleOnClickLogout}
        setLoading={setLoading}
        token={token}
        interceptFunc={true}
      />
      <div className="flex flex-row w-full h-full">
        <SideBar active={"email signatures"} interceptFunc={true} />
        <div className="flex flex-col w-full">
          <Breadcrumb breads={breads} changeBreadCrumbs={changeBreadCrumbs} />
          <div className="flex flex-col w-full h-full justify-center items-center">
            {Object.keys(signatureData).length === 0 ? (
              "Loading..."
            ) : (
              <UpdateSignature data_={signatureData} />
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default UpdatedSignature;
